export default "__VITE_ASSET__B$n0Gc1E__"